<template>
  <section>
    <b-table
      :data="shopsData"
      :columns="shopsColumns"
      default-sort="shoppingCenterGroupName"
      default-sort-direction="asc"

    ></b-table>
  </section>
</template>
<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import type { Section, Shop } from '@/stores/app';

interface SuccessRevenueRow {
  shoppingCenterGroupName: string | undefined;
  shoppingCenterName: string | undefined;
  shopName: string;
  sectionName: string | undefined;
  revenueValue: number | undefined;
}

type SuccessShop = Shop & { sections?: Section[] };

export default defineComponent({
  props: {
    shops: {
      type: Array as PropType<SuccessShop[]>,
      default: () => [],
    },
  },
  data() {
    return {
      shopsColumns: [
        {
          cellClass: 'has-text-right',
          field: 'shoppingCenterGroupName',
          label: this.$t('ShoppingCenterGroupName'),
          sortable: true,
        },
        {
          cellClass: 'has-text-right',
          field: 'shoppingCenterName',
          label: this.$t('ShoppingCenterName'),
          sortable: true,
        },
        {
          cellClass: 'has-text-right',
          field: 'shopName',
          label: this.$t('ShopName'),          
          sortable: true,
        },
        {
          cellClass: 'has-text-right',
          field: 'sectionName',
          label: this.$t('SectionName'),
          sortable: true,
        },
        {
          cellClass: 'has-text-right',
          field: 'revenueValue',
          label: this.$t('Revenue'),
          sortable: true,
        },
      ],
    };
  },
  computed: {
    shopsData(): SuccessRevenueRow[] {
      return this.shops.flatMap((shop: SuccessShop) =>
        (shop.sections ?? [])
          .filter((section: Section) => section.updateSucceed === true)
          .map((shopSection: Section) => ({
            shoppingCenterGroupName: shop.shoppingCenterGroupName,
            shoppingCenterName: shop.shoppingCenterName,
            shopName: shop.shopName,
            sectionName: shopSection.sectionName,
            revenueValue: shopSection.revenueValue,
          }))
      );
    },
  },
});
</script>
